// extracted by mini-css-extract-plugin
module.exports = {"activityContainer":"ActivityContainer_activityContainer__31xJh","errorBoundry":"ActivityContainer_errorBoundry__2YuJu"};